import { render, staticRenderFns } from "./PesquisaMensagemVetoShow.vue?vue&type=template&id=77496dbb&scoped=true"
import script from "./PesquisaMensagemVetoShow.vue?vue&type=script&lang=js"
export * from "./PesquisaMensagemVetoShow.vue?vue&type=script&lang=js"
import style0 from "./PesquisaMensagemVetoShow.vue?vue&type=style&index=0&id=77496dbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77496dbb",
  null
  
)

export default component.exports